
import { useIsAdmin } from '../../hooks/isAdmin';
import { useEffect, useState } from 'react';

import { TagsPicker } from './TagsPicker';
import { Button, Header } from 'semantic-ui-react'

import { useQuery, gql, useMutation } from '@apollo/client';

import { GET_TAGS as GET_POSSIBLE_TAGS } from '../../queries/tags';

const GET_EDIT_PERMISSIONS = gql`
    query User($personId: Int!) {
        user(personId: $personId) {
            visibilityFormula
            editFormula
        }
    }
`;

const UPDATE_USER_PERMISSIONS = gql`
    mutation UpdateUserPermissions($userId: Int!, $visibilityFormula: String!, $editFormula: String!) {
        updateUserPermissions(userId: $userId, visibilityFormula: $visibilityFormula, editFormula: $editFormula) {
            status
        }
    }
`;

const getSets = (str: string) => {
    return str.split('+').map((set) => {
        set = set.slice(1, -1);
        return set.split('x').map((num) => parseInt(num, 10));
    });
};

const setsToString = (sets: number[][]) => {
    return sets.map((set) => {
        // filter out NaN
        set = set.filter((num) => !isNaN(num));

        return '(' + set.join('x') + ')';
    }).join('+');
};

const PermissionEditor = ({ userId, refetchPerson }: { userId: number, refetchPerson: any }) => {
    const isAdmin = useIsAdmin();

    // TODO: get my permissions

    // format is '(1x3x4)+(2x4)+(3x5)'
    // where each set is a list of tag ids
    // and each tag id is separated by 'x' meaning intersection
    // and each set is separated by '+' meaning union of sets

    const [visibilityString, setVisibilityString] = useState('');
    const [editingString, setEditingString] = useState('');

    const [updateUserTags] = useMutation(UPDATE_USER_PERMISSIONS);

    const { loading, error, data} = useQuery(GET_POSSIBLE_TAGS, {
        variables: {
            showPeopleTags: true,
            showCourseTags: true,
            includeAllTags: true,
        }
    });
    const { loading: l, error: e, data: d, refetch } = useQuery(GET_EDIT_PERMISSIONS, {
        variables: { personId: Number(userId) }
    });

    // set the visibility and editing strings when we have the permissions data
    useEffect(() => {
        if (d) {
            setVisibilityString(d.user.visibilityFormula || "");
            setEditingString(d.user.editFormula || "");
        }
    }, [d]);

    if (!isAdmin) {
        return null
    }

    const visibilitySets = getSets(visibilityString);
    const handleSetVisibilityString = (index: number) => ({variables}: {variables: any}) => {
        const { tagIds } = variables
        visibilitySets[index] = tagIds;
        setVisibilityString(setsToString(visibilitySets))
    };

    const editorSets = getSets(editingString);
    const handleSetEditorString = (index: number) => ({variables}: {variables: any}) => {
        const { tagIds } = variables
        editorSets[index] = tagIds;
        setEditingString(setsToString(editorSets))
    };

    return (
        <>
            <Header>Permissions</Header>
            <Header as='h4'>What they can see:</Header>
            {visibilitySets.map((s, index) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <TagsPicker
                            tags={s.map((id) => ({id}))}
                            refetchParent={refetchPerson}
                            loading={loading}
                            error={error}
                            data={data}
                            updateTags={handleSetVisibilityString(index)}
                            payload={{ userId: Number(userId) }}
                        />
                            {visibilitySets.length > 1 && <Button
                                onClick={() => {
                                    visibilitySets.splice(index, 1)
                                    setVisibilityString(setsToString(visibilitySets))
                                }}
                            >
                                -
                            </Button>}
                    </div>
                )
            })}
            <Button
                onClick={() => setVisibilityString(visibilityString + '+()')}
            >
                +
            </Button>
            <Header as='h4'>What they can edit:</Header>
            {editorSets.map((s, index) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <TagsPicker
                            tags={s.map((id) => ({id}))}
                            refetchParent={refetchPerson}
                            loading={loading}
                            error={error}
                            data={data}
                            updateTags={handleSetEditorString(index)}
                            payload={{ userId: Number(userId) }}
                        />
                        {editorSets.length > 1 && <Button
                            onClick={() => {
                                editorSets.splice(index, 1)
                                setEditingString(setsToString(editorSets))
                            }}
                        >
                            -
                        </Button>}
                    </div>
                )
            })}
            <Button
                onClick={() => setEditingString(editingString + '+()')}
            >
                +
            </Button>
            <Button
                primary
                onClick={() => {

                    updateUserTags({
                        variables: {
                            userId: Number(userId),
                            visibilityFormula: visibilityString,
                            editFormula: editingString,
                        }
                    })

                    setTimeout(() => {
                        refetch()
                    }, 1000)
                }}
            >
                Save
            </Button>
        </>
    )
}

export { PermissionEditor }
